/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Autocomplete,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import API from "../../Utils/Interceptor/ApiMiddleware";
import DynamicForm from "../../components/Composables/DynamicForm";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";

function AddUser({
  open,
  onClose,
  apiData,
  id,
  defaultSelectedAdminRef,
  tempSelectedCompanyAdmin,
}) {
  const [tab, setTab] = useState(0);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formConfigurations, setFormConfigurations] = useState();
  const [childAuthorities, setChildAuthorities] = useState([]);
  const [listOfCompanies, setListOfCompanies] = useState([]);
  const [listOfBranches, setListOfBranches] = useState([]);
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const [formState, setFormState] = useState({
    empUserId: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    roleType: "",
    underAssignedUserId: "",
    company: 1,
    selectedCompanies: [],
    selectedBranches: [],
  });

  const validateForm = (activeTab, type) => {
    const newErrors = {};

    if (activeTab === 0) {
      if (!formState.empUserId) newErrors.empUserId = "Please select employer";

      if (!formState.firstName) newErrors.firstName = "First Name is required";

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!formState.email) {
        newErrors.email = "Email is required";
      } else if (!emailRegex.test(formState.email)) {
        newErrors.email = "Invalid email format";
      }

      if (type === "add") {
        if (!formState.password) newErrors.password = "Password is required";

        if (!formState.confirmPassword)
          newErrors.confirmPassword = "Confirm Password is required";
        else if (
          !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
            formState.password
          )
        ) {
          newErrors.password =
            "Password must be at least 8 characters long, contain uppercase and lowercase letters, a number, and a special character";
        }

        if (formState.password !== formState.confirmPassword) {
          newErrors.confirmPassword = "Passwords do not match";
        }
      }
    }

    if (activeTab === 1) {
      if (!formState.roleType) newErrors.roleType = "Please select a role";
      if (!formState.underAssignedUserId)
        newErrors.underAssignedUserId = "Assign Under is required";
    }

    if (activeTab === 2) {
      if (type === "add") {
        if (
          formState.company === 0 &&
          formState.selectedCompanies.length === 0
        ) {
          newErrors.selectedCompanies = "Please select at least one company";
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [step, setStep] = useState(1); // 1 for users, 2 for companies
  const [openPopup, setOpenPopup] = useState(false);
  const [tempRole, setTempRole] = useState(null);
  const [recruiterRadio, setRecruiterRadio] = useState(true);
  const [assignedUserData, setAssignedUserData] = useState([]);
  const [selectedAssignedAdmins, setSelectedAssignedAdmins] = useState({}); // Store selected admin per user
  const [isAssigneeSelected, setIsAssigneeSelected] = useState(true);
  const [selectedCompanyAdmin, setSelectedCompanyAdmin] = useState({});
  const [defaultSelectedCompanyAdmin, setDefaultSelectedCompanyAdmin] =
    useState({});
  const [updateAssignedUserState, setUpdateAssignedUserState] = useState([]);
  const [assignedUserAuthorityLists, setAssignedUserAuthorityLists] = useState(
    {}
  ); // Store authority list per user
  const [isCompanySet, setIsCompanySet] = useState(false);

  const fetchAssignedUsers = async () => {
    if (!id) {
      return;
    }
    try {
      const response = await API.get(`/user/assigned-user-info/${id}`);
      if (response) {
        setAssignedUserData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching assigned user info:", error);
    }
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setTempRole(null);
  };

  const handleApply = () => {
    let isAssigneAssigned = true;
    if (formState.roleType !== "4") {
      Object.values(selectedCompanyAdmin).forEach((entry) => {
        if (!(Object.keys(entry).length > 0)) {
          isAssigneAssigned = false;
          return;
        }
      });
    }
    if (isAssigneAssigned) {
      if (tempRole) {
        setFormState((prev) => ({
          ...prev,
          roleType: tempRole,
        })); // Apply the temporary role selection
        setTempRole(null);
      }

      // console.log("defaultSelectedCompanyAdmin: ", defaultSelectedCompanyAdmin);
      // console.log("selectedCompanyAdmin: ", selectedCompanyAdmin);

      // if (!defaultSelectedAdminRef.current) {
      //   defaultSelectedAdminRef.current = selectedAdmin;
      // }

      if (
        JSON.stringify(defaultSelectedCompanyAdmin) !==
        JSON.stringify(selectedCompanyAdmin)
      ) {
        const updatedCompanies = Object.entries(selectedCompanyAdmin)
          .filter(([_, name]) => name.id === apiData?.["Basic Info"].user_id) // Filter matching entries
          .map(([id]) => {
            const company =
              apiData?.["Companies List"]?.find(
                (company) => company.id === id
              ) || {}; // Find matching company

            return {
              id,
              name: company.name || "",
            };
          });

        setFormState((prev) => ({
          ...prev,
          selectedCompanies: updatedCompanies,
        }));
      }

      setOpenPopup(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    if (!validateForm(tab, apiData ? "edit" : "add")) {
      return;
    }
    setTab(newValue);
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "roleType") {
      if (
        assignedUserData.length > 0 ||
        Object.keys(selectedCompanyAdmin).length > 0
      ) {
        setTempRole(value); // Store role temporarily
        if (formState.roleType !== value.toString()) {
          setOpenPopup(true); // Open the confirmation dialog
        } else {
          setFormState((prev) => ({
            ...prev,
            [name]: value, // Directly update role if no assigned users
          }));
          setFormState((prev) => ({
            ...prev,
            underAssignedUserId: "",
          }));
          setTempRole(null);
        }
      } else {
        setFormState((prev) => ({
          ...prev,
          [name]: value, // Directly update role if no assigned users
        }));
        setFormState((prev) => ({
          ...prev,
          underAssignedUserId: "",
        }));
      }
    } else if (name === "underAssignedUserId") {
      setFormState((prev) => ({
        ...prev,
        [name]: value,
      }));
      setIsCompanySet(true);

      const selectedUser = childAuthorities.find((auth) => auth.id === value);
      if (selectedUser) {
        getCompanyLists(selectedUser.id);
      }
    } else {
      setFormState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getCompanyLists = async (id) => {
    try {
      const response = await API.post("/user/list-of-companies", {
        under_assigned_user_id: id,
      });

      setListOfCompanies(response.data.data);
    } catch (error) {
      console.error("Error fetching company lists:", error);
      setListOfCompanies([]);
      setFormState((prev) => ({
        ...prev,
        selectedCompanies: [],
      }));
    }
  };
  const branchesList = async (user_id, company_id) => {
    if (!user_id || !company_id) {
      console.warn("user_id or company_id missing");
      return;
    }

    try {
      const response = await API.get("/user/get-branches-list", {
        params: { user_id, company_id },
      });

      setListOfBranches((prev) => ({
        ...prev,
        [company_id]: response.data.data,
      }));
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const handleChange = (key, value, inputValue = null) => {
    setFormState((prev) => ({
      ...prev,
      [key]: value,
      roleType: "",
      underAssignedUserId: "",
      selectedBranches: [],
      selectedCompanies: [],
      // [`${key}Input`]: inputValue !== null ? inputValue : prev[`${key}Input`],
    }));
    setChildAuthorities([]);
    setListOfBranches({});
    setListOfCompanies([]);
  };

  const handleClose = () => {
    setFormState({
      empUserId: "",
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      roleType: "",
      underAssignedUserId: "",
      company: 1,
      selectedCompanies: [],
      selectedBranches: [],
    });
    setListOfBranches([]);
    setListOfCompanies([]);
    onClose();
    setTab(0);
    setErrors({});
  };

  const handleNext = () => {
    if (!validateForm(tab, apiData ? "edit" : "add")) {
      return;
    }
    setTab((prevTab) => prevTab + 1);
  };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleAdd = async () => {
    if (!validateForm()) {
      return;
    }
    const payload = {
      emp_user_id: formState.empUserId,
      firstName: formState.firstName,
      lastName: formState.lastName,
      email: formState.email,
      password: formState.password,
      role_id: formState.roleType,
      under_assigned_user_id: formState.underAssignedUserId,
      companiesList: formState.company === 1 ? [-100] : selectedCompanyIds,
      companiesBranchList: selectedBranches,
    };

    // console.log("payload: ", payload);

    try {
      const response = await API.post("/user/create-user", payload);

      if (response.data.success) {
        setSnackbar({
          open: true,
          message: response.data.data.msg,
          severity: "success",
        });
        setTimeout(() => window.location.reload(), 1000);
      } else {
        setSnackbar({
          open: true,
          message: response.data.data.msg,
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error adding user:", error);
      setSnackbar({
        open: true,
        message: error.response.data.message,
        severity: "error",
      });
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) {
      return;
    }
    const payload = {
      emp_user_id: formState.empUserId,
      firstName: formState.firstName,
      lastName: formState.lastName,
      email: formState.email,
      user_role_id: formState.roleType,
      under_assigned_user_id: formState.underAssignedUserId,
      companiesList: formState.company === 1 ? [-100] : selectedCompanyIds,
      companiesBranchList: selectedBranches,
      original_date_modified: formState.original_date_modified,
    };

    // console.log("payload--", payload);
    // console.log("updateAssignedUserState--", updateAssignedUserState);

    try {
      await API.post(`/user/edit-assignedUnder-user`, updateAssignedUserState);
      tempSelectedCompanyAdmin.current = null;
    } catch (error) {
      console.error(error);
    }

    try {
      const response = await API.post(`/user/edit-user/${id}`, payload);
      if (response.data.success) {
        setSnackbar({
          open: true,
          message: response.data.data,
          severity: "success",
        });
        setTimeout(() => window.location.reload(), 1000);
      } else {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error updating user:", error);
      setSnackbar({
        open: true,
        message: error.response.data.message,
        severity: "error",
      });
    }
  };

  const fetchEmployersData = async () => {
    try {
      const response = await API.get("employer/get-employer-filter-details");
      if (response) {
        const apiData = response.data.data;
        const NameOptions = apiData?.map((item) => ({
          value: item.user_id,
          label: item.name,
        }));

        const formConfigurations = [
          {
            label: "Select Employer",
            type: "autocomplete-single",
            name: "empUserId",
            options: NameOptions,
          },
        ];

        setFormConfigurations(formConfigurations);
      }
    } catch (error) {
      console.error("Error fetching employer filter data:", error);
    }
  };

  const selectedCompanyIds =
    formState.company === 1
      ? listOfCompanies.map((c) => c.id) // All companies
      : formState.selectedCompanies; // Only selected companies

  const selectedBranches = selectedCompanyIds.map((companyId) => {
    const branchKey = `companyBranches_${companyId}`;
    const branches = formState[branchKey] ?? [-100];

    return {
      company_id: companyId,
      branches: branches.length > 0 ? branches : [-100],
    };
  });

  const fetchAssignedChildAuthority = async (roleId, userId) => {
    try {
      const response = await API.post("/user/get-child-authority", {
        user_id: formState.empUserId,
        role_id: roleId,
      });

      if (response?.data?.data) {
        const list = response.data.data;

        setAssignedUserAuthorityLists((prev) => ({
          ...prev,
          [userId]: list,
        }));
      }
    } catch (error) {
      console.error("Error fetching assigned child authority: ", error);
    }
  };

  const fetchChildAuthority = async (roleId) => {
    if (!formState.empUserId) {
      console.error("No employer selected");
      return;
    }

    try {
      const response = await API.post("/user/get-child-authority", {
        user_id: formState.empUserId,
        role_id: roleId,
      });

      if (response?.data?.data) {
        let list = response.data.data;

        if (
          apiData?.["Basic Info"] &&
          Object.keys(apiData?.["Basic Info"]).length > 0
        ) {
          list = [
            {
              user_id: apiData?.["Basic Info"]?.user_id,
              name: apiData?.["Basic Info"].user_name,
            },
            ...list,
          ];
        }

        const authorityOptions = list?.map((item) => ({
          id: item.user_id,
          label: item.name,
        }));
        setChildAuthorities(authorityOptions);
      }
    } catch (error) {
      console.error("Error fetching child authority:", error);
    }
  };

  useEffect(() => {
    if (open) {
      fetchEmployersData();
      fetchAssignedUsers();
    }

    if (open && apiData) {
      getCompanyLists(apiData?.["Basic Info"].under_assigned_user_id);

      const branchData = {};
      apiData?.["Companies List"].forEach((item) => {
        if (!item.has_full_branch_access) {
          branchData[`companySelection_${item.id}`] = "Select";
          branchData[`companyBranches_${item.id}`] = item.branches.map(
            (i) => i.branch_id
          );

          apiData?.["Companies List"].forEach((item) => {
            branchesList(
              apiData?.["Basic Info"].under_assigned_user_id,
              item.id
            );
          });
        }
      });

      if (apiData?.["Companies List"]?.length > 0) {
        var selectedCompanyAdminValue = (prev) => {
          const updatedCompanies = { ...prev };
          apiData?.["Companies List"].forEach((company) => {
            if (!updatedCompanies[company.id]) {
              updatedCompanies[company.id] = {
                id: apiData?.["Basic Info"]?.user_id,
                label: apiData?.["Basic Info"]?.user_name,
              };
            }
          });
          return updatedCompanies;
        };
        setSelectedCompanyAdmin(selectedCompanyAdminValue);
        setDefaultSelectedCompanyAdmin(selectedCompanyAdminValue);
      }

      // await fetchEmployersData();
      setFormState((prev) => ({
        ...prev,
        ...branchData,
        empUserId: apiData?.["Basic Info"].emp_user_id,
        firstName: apiData?.["Basic Info"].firstName,
        lastName: apiData?.["Basic Info"].lastName,
        email: apiData?.["Basic Info"].email,
        roleType: apiData?.["Basic Info"].role_id,
        underAssignedUserId: apiData?.["Basic Info"].under_assigned_user_id,
        company: apiData?.["Basic Info"].has_full_company_access,
        selectedCompanies: apiData?.["Basic Info"].has_full_company_access
          ? []
          : apiData?.["Companies List"].map((item) => item.id),
        original_date_modified: apiData?.["Basic Info"].original_date_modified,
      }));
    }
  }, [open]);

  useEffect(() => {
    if (formState.roleType) {
      fetchChildAuthority(formState.roleType);
    }
  }, [formState.roleType]);

  useEffect(() => {
    // Fetch authority lists for all users when popup opens
    if (openPopup) {
      let isAssigneAssigned = true;

      Object.values(selectedCompanyAdmin).forEach((entry) => {
        if (!(Object.keys(entry).length > 0)) {
          isAssigneAssigned = false;
          return;
        }
      });
      setIsAssigneeSelected(isAssigneAssigned);

      assignedUserData?.forEach((user) => {
        if (user.role_id) {
          fetchAssignedChildAuthority(user.role_id, user.user_id);
        }
      });
    }

    // Initialize default names  for each assigned user and company
    if (assignedUserData?.length > 0) {
      setSelectedAssignedAdmins((prev) => {
        const updatedAdmins = { ...prev };
        assignedUserData.forEach((user) => {
          if (!updatedAdmins[user.user_id]) {
            updatedAdmins[user.user_id] = apiData?.["Basic Info"]?.user_name;
          }
        });
        return updatedAdmins;
      });
    }
  }, [openPopup, assignedUserData]);

  useEffect(() => {
    if (isCompanySet) {
      if (
        defaultSelectedAdminRef?.current?.username.includes("(Recruiter)") &&
        formState.roleType === 3
      ) {
        if (
          !defaultSelectedAdminRef?.current.hierarchy_id.includes(
            formState.underAssignedUserId
          )
        ) {
          if (tempSelectedCompanyAdmin.current == null) {
            tempSelectedCompanyAdmin.current = selectedCompanyAdmin;
          }
          let isTrue = true;
          Object.keys(selectedCompanyAdmin).forEach((el) => {
            isTrue = true;
            listOfCompanies.forEach((element) => {
              if (element.id === Number(el)) {
                isTrue = false;
              }
            });

            if (isTrue) {
              let elValue = {
                id: defaultSelectedAdminRef?.current?.id,
                name: defaultSelectedAdminRef?.current?.name,
              };

              setSelectedCompanyAdmin((prevState) => ({
                ...prevState,
                [el]: elValue || {},
              }));
            }
          });
          if (isTrue) {
            setFormState((prev) => ({
              ...prev,
              selectedCompanies: [],
            }));
            setSnackbar({
              open: true,
              message:
                "The recruiter will not be able to take the previously assigned companies to the new hierarchy.",
              severity: "warning",
            });
          }
        } else if (
          snackbar.message ===
          "The recruiter will not be able to take the previously assigned companies to the new hierarchy."
        ) {
          setFormState((prev) => ({
            ...prev,
            selectedCompanies: Object.keys(
              tempSelectedCompanyAdmin.current
            ).map(Number),
          }));

          setSelectedCompanyAdmin(tempSelectedCompanyAdmin.current);

          setSnackbar({
            open: true,
            message:
              "The recruiter will be able to take the previously assigned companies.",
            severity: "warning",
          });
        }
      }
      setIsCompanySet(false);
    }
  }, [listOfCompanies]);

  useEffect(() => {
    if (apiData?.["Basic Info"]?.user_id) {
      const assignedUserData = {
        user_id: Object.entries(selectedAssignedAdmins).map(([id, name]) => {
          const assignedList = assignedUserAuthorityLists[id] || [];
          const matchedUser = assignedList.find((user) => user.name === name);

          return {
            id: Number(id),
            assignedUnder_name: name,
            assignedUnder_ID: matchedUser
              ? matchedUser.user_id
              : apiData?.["Basic Info"].user_id,
          };
        }),

        assignedCompanies: Object.entries(selectedCompanyAdmin)
          .filter(
            ([_, company]) => company.id !== apiData?.["Basic Info"].user_id
          )
          .map(([id, name]) => ({
            id: Number(id),
            assignedUnder_name: name,
            current_userId: apiData?.["Basic Info"].user_id,
          })),

        emp_user_id: formState.empUserId,
      };
      // console.log("assignedUserData: ", assignedUserData);

      setUpdateAssignedUserState(assignedUserData);
    }
  }, [selectedAssignedAdmins, selectedCompanyAdmin]); // Runs when dependencies change

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
      }}
      disableEscapeKeyDown
      fullWidth
      sx={{ "& .MuiDialog-paper": { borderRadius: "16px" } }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          padding: "16px 24px",
          borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
        }}
      >
        <DialogTitle
          sx={{ flex: 1, fontSize: "22px", fontWeight: "500", padding: "0px" }}
        >
          {apiData ? "Edit User" : "Add User"}
        </DialogTitle>
        <IconButton onClick={handleClose} sx={{ color: "#101828 !important" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "#F7F8FA",
          backgroundColor: "#F7F8FA",
          padding: "10px 24px 0px 24px",
        }}
      >
        <Tabs value={tab} onChange={handleTabChange} variant="fullWidth">
          <Tab label="Basic Info" sx={{ flex: 1 }} />
          <Tab label="Role Permissions" sx={{ flex: 1 }} />
          <Tab label="Company" sx={{ flex: 1 }} />
          <Tab label="Branch" sx={{ flex: 1 }} />
        </Tabs>
      </Box>
      <DialogContent>
        <Box sx={{ height: "300px", display: "flex", flexDirection: "column" }}>
          {tab === 0 && (
            <Box sx={{ mt: 2, flex: 1 }}>
              {formConfigurations ? (
                <DynamicForm
                  formData={formConfigurations}
                  formState={formState}
                  handleChange={handleChange}
                  error={!!errors.empUserId}
                  helperText={errors.empUserId}
                  disabled={apiData ? true : false}
                  required
                />
              ) : (
                <LoadingSpinner />
              )}

              <Box display="flex" gap={2} mt={2}>
                <TextField
                  size="small"
                  name="firstName"
                  required
                  onChange={handleInputChange}
                  value={formState.firstName}
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  fullWidth
                  label="First Name"
                />
                <TextField
                  size="small"
                  name="lastName"
                  onChange={handleInputChange}
                  value={formState.lastName}
                  fullWidth
                  label="Last Name"
                />
              </Box>
              <TextField
                size="small"
                fullWidth
                label="Email"
                name="email"
                onChange={handleInputChange}
                value={formState.email}
                sx={{ mb: 2, mt: 2 }}
                required
                error={!!errors.email}
                helperText={errors.email}
              />
              {!apiData && (
                <Box display="flex" gap={2}>
                  {/* Select State */}
                  <TextField
                    size="small"
                    margin="dense"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    required
                    variant="outlined"
                    name="password"
                    value={formState.password}
                    onChange={handleInputChange}
                    error={!!errors.password}
                    helperText={errors.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={togglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* Confirm Password */}
                  <TextField
                    size="small"
                    margin="dense"
                    label="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    fullWidth
                    required
                    variant="outlined"
                    name="confirmPassword"
                    value={formState.confirmPassword}
                    onChange={handleInputChange}
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={toggleConfirmPasswordVisibility}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              )}
            </Box>
          )}

          {tab === 1 && (
            <Box sx={{ mt: 2, flex: 1 }}>
              <Typography sx={{ fontWeight: "bold" }}>
                Select Role Type
              </Typography>
              <FormControl
                fullWidth
                required
                size="small"
                sx={{ mb: 2, mt: 2 }}
                error={!!errors.roleType}
              >
                <InputLabel id="role-select-label">Select Role</InputLabel>
                <Select
                  labelId="role-select-label"
                  id="role-select"
                  name="roleType"
                  value={formState.roleType}
                  onChange={handleInputChange}
                  required
                  error={!!errors.roleType}
                  helperText={errors.roleType}
                  label="Select Role"
                >
                  {(!apiData || formState.roleType >= 2) &&
                    formState.roleType !== "5" && (
                      <MenuItem value={2}>Admin</MenuItem>
                    )}

                  {(!apiData || formState.roleType >= 3) &&
                    formState.roleType !== "5" && (
                      <MenuItem value={3}>TA Manager</MenuItem>
                    )}

                  {(!apiData || formState.roleType >= 4) &&
                    formState.roleType !== "5" && (
                      <MenuItem value={4}>Recruiter</MenuItem>
                    )}

                  {(!apiData || formState.roleType >= 5) && (
                    <MenuItem value={5}>ATS User</MenuItem>
                  )}
                </Select>

                {errors.roleType && (
                  <FormHelperText>{errors.roleType}</FormHelperText>
                )}
              </FormControl>

              <Typography sx={{ fontWeight: "bold" }}>
                Assign User Under
              </Typography>
              {/* Employer Name as Assign Under */}
              <FormControl
                fullWidth
                required
                size="small"
                sx={{ mb: 2, mt: 2 }}
                error={!!errors.underAssignedUserId}
              >
                <InputLabel id="assign-under-label">Assign Under</InputLabel>
                <Select
                  labelId="assign-under-label"
                  id="assign-under"
                  name="underAssignedUserId"
                  value={formState.underAssignedUserId}
                  onChange={handleInputChange}
                  required
                  error={!!errors.underAssignedUserId}
                  helperText={errors.underAssignedUserId}
                  label="Assign Under"
                >
                  {childAuthorities.length > 0 ? (
                    childAuthorities
                      ?.filter(
                        (item) =>
                          item.label !== undefined &&
                          item.id !== apiData?.["Basic Info"].user_id
                      )
                      .map((authority) => (
                        <MenuItem key={authority.id} value={authority.id}>
                          {authority.label}
                        </MenuItem>
                      ))
                  ) : (
                    <MenuItem disabled>No options available</MenuItem>
                  )}
                </Select>
                {errors.underAssignedUserId && (
                  <FormHelperText>{errors.underAssignedUserId}</FormHelperText>
                )}
              </FormControl>
            </Box>
          )}

          {tab === 2 && (
            <Box mt={2}>
              {listOfCompanies.length > 0 ? (
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "4.5rem" }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>Company</Typography>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <RadioGroup
                      row
                      name="company"
                      value={formState.company === 1 ? "All" : "Select"}
                      onChange={(event) =>
                        setFormState((prev) => ({
                          ...prev,
                          company: event.target.value === "All" ? 1 : 0,
                          selectedCompanies: [],
                        }))
                      }
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <FormControlLabel
                        value="All"
                        control={<Radio />}
                        label="All"
                      />
                      <FormControlLabel
                        value="Select"
                        control={<Radio />}
                        label="Select"
                      />
                    </RadioGroup>

                    {formState.company === 0 && listOfCompanies.length > 0 && (
                      <FormControl
                        sx={{ minWidth: 200 }}
                        error={!!errors.selectedCompanies}
                        size="small"
                      >
                        <InputLabel>Select Company</InputLabel>
                        <Select
                          size="small"
                          multiple
                          value={formState.selectedCompanies || []}
                          label="Select Company"
                          onChange={(event) =>
                            setFormState((prev) => ({
                              ...prev,
                              selectedCompanies: event.target.value,
                            }))
                          }
                          renderValue={(selected) =>
                            selected.length > 0
                              ? `Selected (${selected.length})`
                              : ""
                          }
                        >
                          {listOfCompanies.map((company) => (
                            <MenuItem key={company.id} value={company.id}>
                              {company.name}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.selectedCompanies && (
                          <FormHelperText>
                            {errors.selectedCompanies}
                          </FormHelperText>
                        )}
                      </FormControl>
                    )}
                  </Box>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexGrow: 1,
                  }}
                >
                  <Typography sx={{ fontWeight: "700" }}>
                    No Companies Available
                  </Typography>
                </Box>
              )}

              {/* Selected Companies as Chips */}
              {formState.selectedCompanies?.length > 0 && (
                <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexWrap: "wrap",
                    p: 1,
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    minHeight: "40px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  {formState.selectedCompanies.map((companyId) => {
                    const company = listOfCompanies.find(
                      (c) => c.id === companyId
                    );
                    return (
                      <Chip
                        key={companyId}
                        label={company?.name}
                        onDelete={() =>
                          setFormState((prev) => ({
                            ...prev,
                            selectedCompanies: prev.selectedCompanies.filter(
                              (id) => id !== companyId
                            ),
                          }))
                        }
                        sx={{ bgcolor: "gray", color: "white" }}
                      />
                    );
                  })}
                </Box>
              )}
            </Box>
          )}

          {tab === 3 && (
            // <Box mt={2}>
            //   {formState.selectedCompanies.length > 0 ||
            //   formState.company === 1 ? (
            //     <Box display="flex" flexDirection="column" gap={2}>
            //       {(() =>formState.company === 1
            //         ? listOfCompanies
            //         : listOfCompanies.filter((company) =>
            //             formState.selectedCompanies.includes(company.id)
            //           )
            //       )
            //         .filter((company) => Number(company.branch_count) > 0)
            //         .map((company) => {
            //           const selectionKey = `companySelection_${company.id}`;
            //           const branchKey = `companyBranches_${company.id}`;
            //           const selectionType = formState[selectionKey] || "All";

            //           return (
            //             <Box
            //               key={company.id}
            //               sx={{
            //                 display: "flex",
            //                 flexDirection: "column",
            //                 gap: 1,
            //               }}
            //             >
            //               <Box
            //                 sx={{
            //                   display: "flex",
            //                   alignItems: "center",
            //                   gap: 2,
            //                 }}
            //               >
            //                 <Typography
            //                   sx={{ fontWeight: "bold", width: "25%" }}
            //                 >
            //                   {company.name}
            //                 </Typography>
            //                 <RadioGroup
            //                   row
            //                   name={`company-${company.id}`}
            //                   value={selectionType}
            //                   onChange={(event) => {
            //                     const value = event.target.value;
            //                     setFormState((prev) => ({
            //                       ...prev,
            //                       [selectionKey]: value,
            //                       [branchKey]: value === "All" ? [-100] : [],
            //                     }));
            //                   }}
            //                 >
            //                   <FormControlLabel
            //                     value="All"
            //                     control={<Radio />}
            //                     label="All"
            //                   />
            //                   <FormControlLabel
            //                     value="Select"
            //                     control={<Radio />}
            //                     label="Select"
            //                   />
            //                 </RadioGroup>
            //                 {selectionType === "Select" && (
            //                   <FormControl sx={{ minWidth: 200 }} size="small">
            //                     <InputLabel>Select Branch</InputLabel>
            //                     <Select
            //                       size="small"
            //                       multiple
            //                       value={formState[branchKey] || []}
            //                       label="Select Branch"
            //                       onFocus={() =>
            //                         branchesList(
            //                           formState.underAssignedUserId,
            //                           company.id
            //                         )
            //                       }
            //                       onChange={(event) => {
            //                         const value = event.target.value;
            //                         setFormState((prev) => ({
            //                           ...prev,
            //                           [branchKey]: value,
            //                         }));
            //                       }}
            //                       renderValue={(selected) =>
            //                         selected.length > 0
            //                           ? `Selected (${selected.length})`
            //                           : "Select Branch"
            //                       }
            //                     >
            //                       {listOfBranches[company.id] &&
            //                       listOfBranches[company.id].length > 0 ? (
            //                         listOfBranches[company.id].map((branch) => (
            //                           <MenuItem
            //                             key={branch.id}
            //                             value={branch.id}
            //                           >
            //                             {branch.branch_name}
            //                           </MenuItem>
            //                         ))
            //                       ) : (
            //                         <MenuItem disabled>
            //                           No Branches Available
            //                         </MenuItem>
            //                       )}
            //                     </Select>
            //                   </FormControl>
            //                 )}
            //               </Box>

            //               {selectionType === "Select" &&
            //                 Array.isArray(formState[branchKey]) &&
            //                 formState[branchKey].length > 0 && (
            //                   <Box
            //                     sx={{
            //                       display: "flex",
            //                       gap: 1,
            //                       flexWrap: "wrap",
            //                       p: 1,
            //                       border: "1px solid lightgray",
            //                       borderRadius: "5px",
            //                       minHeight: "40px",
            //                       backgroundColor: "#f9f9f9",
            //                     }}
            //                   >
            //                     {formState[branchKey].map((branchId) => {
            //                       const branchesForCompany =
            //                         listOfBranches[company.id] || [];

            //                       const branch = branchesForCompany.find(
            //                         (b) => b.id === branchId
            //                       );

            //                       return branch ? (
            //                         <Chip
            //                           key={branchId}
            //                           label={branch.branch_name}
            //                           onDelete={() =>
            //                             setFormState((prev) => ({
            //                               ...prev,
            //                               [branchKey]: prev[branchKey].filter(
            //                                 (id) => id !== branchId
            //                               ),
            //                             }))
            //                           }
            //                           sx={{ bgcolor: "gray", color: "white" }}
            //                         />
            //                       ) : null;
            //                     })}
            //                   </Box>
            //                 )}
            //             </Box>
            //           );
            //         })}
            //     </Box>
            //   ) : (
            //     <Box
            //       sx={{
            //         display: "flex",
            //         justifyContent: "center",
            //         alignItems: "center",
            //         flexGrow: 1,
            //       }}
            //     >
            //       <Typography sx={{ fontWeight: "700" }}>
            //         No Branches Available
            //       </Typography>
            //     </Box>
            //   )}
            // </Box>

            <Box mt={2}>
              {formState.selectedCompanies.length > 0 ||
              formState.company === 1 ? (
                (() => {
                  const selectedCompanies =
                    formState.company === 1
                      ? listOfCompanies
                      : listOfCompanies.filter((company) =>
                          formState.selectedCompanies.includes(company.id)
                        );

                  const companiesWithBranches = selectedCompanies.filter(
                    (company) => Number(company.branch_count) > 0
                  );

                  if (companiesWithBranches.length === 0) {
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexGrow: 1,
                        }}
                      >
                        <Typography sx={{ fontWeight: "700" }}>
                          The selected company have no branches
                        </Typography>
                      </Box>
                    );
                  }

                  return (
                    <Box display="flex" flexDirection="column" gap={2}>
                      {companiesWithBranches.map((company) => {
                        const selectionKey = `companySelection_${company.id}`;
                        const branchKey = `companyBranches_${company.id}`;
                        const selectionType = formState[selectionKey] || "All";

                        return (
                          <Box
                            key={company.id}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              <Typography
                                sx={{ fontWeight: "bold", width: "25%" }}
                              >
                                {company.name}
                              </Typography>

                              <RadioGroup
                                row
                                name={`company-${company.id}`}
                                value={selectionType}
                                onChange={(event) => {
                                  const value = event.target.value;
                                  setFormState((prev) => ({
                                    ...prev,
                                    [selectionKey]: value,
                                    [branchKey]: value === "All" ? [-100] : [],
                                  }));
                                }}
                              >
                                <FormControlLabel
                                  value="All"
                                  control={<Radio />}
                                  label="All"
                                />
                                <FormControlLabel
                                  value="Select"
                                  control={<Radio />}
                                  label="Select"
                                />
                              </RadioGroup>

                              {selectionType === "Select" && (
                                <FormControl
                                  sx={{ minWidth: 200 }}
                                  size="small"
                                >
                                  <InputLabel>Select Branch</InputLabel>
                                  <Select
                                    size="small"
                                    multiple
                                    value={formState[branchKey] || []}
                                    label="Select Branch"
                                    onFocus={() =>
                                      branchesList(
                                        formState.underAssignedUserId,
                                        company.id
                                      )
                                    }
                                    onChange={(event) => {
                                      const value = event.target.value;
                                      setFormState((prev) => ({
                                        ...prev,
                                        [branchKey]: value,
                                      }));
                                    }}
                                    renderValue={(selected) =>
                                      selected.length > 0
                                        ? `Selected (${selected.length})`
                                        : "Select Branch"
                                    }
                                  >
                                    {listOfBranches[company.id] &&
                                    listOfBranches[company.id].length > 0 ? (
                                      listOfBranches[company.id].map(
                                        (branch) => (
                                          <MenuItem
                                            key={branch.id}
                                            value={branch.id}
                                          >
                                            {branch.branch_name}
                                          </MenuItem>
                                        )
                                      )
                                    ) : (
                                      <MenuItem disabled>
                                        No Branches Available
                                      </MenuItem>
                                    )}
                                  </Select>
                                </FormControl>
                              )}
                            </Box>

                            {selectionType === "Select" &&
                              Array.isArray(formState[branchKey]) &&
                              formState[branchKey].length > 0 && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: 1,
                                    flexWrap: "wrap",
                                    p: 1,
                                    border: "1px solid lightgray",
                                    borderRadius: "5px",
                                    minHeight: "40px",
                                    backgroundColor: "#f9f9f9",
                                  }}
                                >
                                  {formState[branchKey].map((branchId) => {
                                    const branchesForCompany =
                                      listOfBranches[company.id] || [];

                                    const branch = branchesForCompany.find(
                                      (b) => b.id === branchId
                                    );

                                    return branch ? (
                                      <Chip
                                        key={branchId}
                                        label={branch.branch_name}
                                        onDelete={() =>
                                          setFormState((prev) => ({
                                            ...prev,
                                            [branchKey]: prev[branchKey].filter(
                                              (id) => id !== branchId
                                            ),
                                          }))
                                        }
                                        sx={{ bgcolor: "gray", color: "white" }}
                                      />
                                    ) : null;
                                  })}
                                </Box>
                              )}
                          </Box>
                        );
                      })}
                    </Box>
                  );
                })()
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexGrow: 1,
                  }}
                >
                  <Typography sx={{ fontWeight: "700" }}>
                    No Branches Available
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          width: "100%",
          padding: "16px 24px",
          borderTop: "1px solid rgba(0, 0, 0, 0.10)",
        }}
      >
        <Button
          onClick={tab === 0 ? handleClose : () => setTab(tab - 1)}
          variant="outlined"
          sx={{ flex: 1, textTransform: "none", padding: "10px" }}
        >
          {tab === 0 ? "Cancel" : "Back"}
        </Button>
        <Button
          variant="contained"
          sx={{ flex: 1, textTransform: "none", padding: "10px" }}
          onClick={
            tab === 3 ? (apiData ? handleUpdate : handleAdd) : handleNext
          }
        >
          {tab === 3 ? (apiData ? "Update" : "Add") : "Next"}
        </Button>
      </DialogActions>
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />

      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {step === 1 && assignedUserData.length > 0
            ? "Assigned Users"
            : "Assigned Companies"}
        </DialogTitle>
        <DialogContent>
          {step === 1 && assignedUserData.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Username</TableCell>
                  <TableCell>Assign User Under</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {assignedUserData?.map((user) => (
                  <TableRow key={user.user_id}>
                    <TableCell>{user.user_name}</TableCell>
                    <TableCell>
                      <Autocomplete
                        freeSolo
                        disableClearable
                        id={`autocomplete-user-${user.user_id}`}
                        options={
                          assignedUserAuthorityLists[user.user_id]?.map(
                            (item) => item.name
                          ) || [] // Extract names
                        }
                        value={
                          selectedAssignedAdmins[user.user_id] ||
                          selectedAssignedAdmins.name
                        }
                        onChange={(e, newValue) => {
                          setSelectedAssignedAdmins((prev) => ({
                            ...prev,
                            [user.user_id]: newValue,
                          }));
                        }}
                        onInputChange={(e, newInputValue) => {
                          if (newInputValue === "") {
                            setSelectedAssignedAdmins((prev) => ({
                              ...prev,
                              [user.user_id]: "",
                            }));
                            setIsAssigneeSelected(false);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select"
                            error={
                              selectedAssignedAdmins[user.user_id] ||
                              selectedAssignedAdmins.name
                                ? false
                                : true
                            }
                            helperText={
                              selectedAssignedAdmins[user.user_id] ||
                              selectedAssignedAdmins.name
                                ? ""
                                : "Please select assignee"
                            }
                          />
                        )}
                        fullWidth
                        disabled={!user.role_id}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            // Step 2: Assigned Companies View
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Company Name</TableCell>
                  {formState.roleType === "4" ? (
                    <TableCell>Do you wish to assign company?</TableCell>
                  ) : (
                    <TableCell>Assign Company Under</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {apiData &&
                  apiData?.["Companies List"]?.map((company) => (
                    <TableRow key={company.id}>
                      <TableCell>{company.name}</TableCell>
                      <TableCell>
                        {formState.roleType === "4" ? (
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="demo-radio-buttons-group-label"
                              defaultValue={recruiterRadio ? "yes" : "no"}
                              // value={recruiterRadio ? "yes" : "no"}
                              name="radio-buttons-group"
                              onChange={(e) => {
                                if (e.target.value === "yes") {
                                  setRecruiterRadio(true);
                                  setSelectedCompanyAdmin((prevState) => ({
                                    ...prevState,
                                    [company.id]:
                                      Object.values(childAuthorities).find(
                                        (item) =>
                                          item.label ===
                                          defaultSelectedAdminRef?.current
                                            ?.username
                                      ) || {},
                                  }));
                                } else {
                                  setRecruiterRadio(false);
                                  setSelectedCompanyAdmin((prevState) => ({
                                    ...prevState,
                                    [company.id]:
                                      Object.values(childAuthorities).find(
                                        (item) =>
                                          item.label ===
                                          defaultSelectedAdminRef?.current?.name
                                      ) || {},
                                  }));
                                }
                              }}
                            >
                              <FormControlLabel
                                value="yes"
                                control={<Radio />}
                                label="Yes"
                              />
                              <FormControlLabel
                                value="no"
                                control={<Radio />}
                                label="No"
                              />
                            </RadioGroup>
                          </FormControl>
                        ) : (
                          <Autocomplete
                            freeSolo
                            disableClearable
                            id={`autocomplete-user-under-${company.id}`}
                            style={{ width: "100%" }}
                            options={
                              Object.values(childAuthorities)?.map(
                                (item) => item.label
                              ) || [] // Extract names
                            }
                            value={
                              selectedCompanyAdmin[company.id]?.label || ""
                            }
                            onChange={(e, newValue) => {
                              setSelectedCompanyAdmin((prevState) => ({
                                ...prevState,
                                [company.id]:
                                  Object.values(childAuthorities).find(
                                    (item) => item.label === newValue
                                  ) || {},
                              }));
                            }}
                            onInputChange={(e, newInputValue) => {
                              if (newInputValue === "") {
                                setSelectedCompanyAdmin((prevState) => ({
                                  ...prevState,
                                  [company.id]: {}, // Clear the selection for this company
                                }));
                                setIsAssigneeSelected(false);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select"
                                error={
                                  selectedCompanyAdmin[company.id]?.label
                                    ? false
                                    : true
                                }
                                helperText={
                                  selectedCompanyAdmin[company.id]?.label
                                    ? ""
                                    : "Please select assignee"
                                }
                                style={{ height: "100%" }}
                              />
                            )}
                            fullWidth
                            // disabled={!role}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </DialogContent>
        <DialogActions>
          {step === 2 && assignedUserData.length > 0 ? (
            <Button onClick={() => setStep(1)} color="primary">
              Back
            </Button>
          ) : (
            <Button onClick={handleClosePopup} color="primary">
              Close
            </Button>
          )}
          {step === 1 && assignedUserData.length > 0 ? (
            isAssigneeSelected ? (
              <Button
                variant="contained"
                onClick={() => {
                  let isAssigneAssigned = true;
                  Object.values(selectedAssignedAdmins).forEach((entry) => {
                    if (!(Object.keys(entry).length > 0)) {
                      isAssigneAssigned = false;
                      return;
                    }
                  });
                  if (isAssigneAssigned) {
                    setStep(2);
                  }
                }}
              >
                Next
              </Button>
            ) : (
              <Button variant="contained" disabled>
                Next
              </Button>
            )
          ) : isAssigneeSelected ? (
            <Button variant="contained" onClick={handleApply}>
              Apply
            </Button>
          ) : (
            <Button variant="contained" disabled>
              Apply
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Dialog>
  );
}

export default AddUser;
